import authService from '../auth/authService';


export default {
  install(Vue) {
    Vue.prototype.$auth = authService;

    Vue.mixin({
      data() {
        return {
          // Excel
          filterForExcel: {},
          sortForExcel: {},
        }
      },
      created() {
        if (this.handleLoginEvent) {
          authService.addListener('loginEvent', this.handleLoginEvent);
        }
      },

      destroyed() {
        if (this.handleLoginEvent) {
          authService.removeListener('loginEvent', this.handleLoginEvent);
        }
      },
      methods: {
        successAlert(title, text) {
          this.$vs.notify({
            title: title,
            text: text,
            time: 8000,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'primary'
          })
        },
        errorAlert(title, text) {
          this.$vs.notify({
            title: title,
            text: text,
            time: 8000,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        },
        infoAlert(title, text) {
          this.$vs.notify({
            title: title,
            text: text,
            time: 8000,
            iconPack: 'feather',
            icon: 'icon-alert-triangle',
            color: 'warning'
          })
        },
        XSSCheck(str, level) {
          if (level == undefined || level == 0) {
            str = str.replace(/\<|\>|\"|\'|\%|\;|\(|\)|\&|\+|\-/g, "");
          } else if (level != undefined && level == 1) {
            str = str.replace(/\</g, "&lt;");
            str = str.replace(/\>/g, "&gt;");
            str = str.replace(/\"/g, "&quot;");
          }
          return str;
        },
        // Table
        onLoading() {
          this.$vs.loading()
        },
        onLoaded() {
          this.$vs.loading.close()
        },
        // Excel
        setSortedForExcel(sorted) {
          this.sortForExcel = sorted
        },
        setFilterForExcel(filter) {
          let name = filter.name
          this.filterForExcel[name] = filter.value
        },
        setFilterForExcelIncludeDateFilter(filter) {
          let name = filter.name
          let dateStr = "vf__"

          if (name.includes(dateStr)) {
            let replaceName = name.replace(dateStr, '') + "UTC"
            if (filter.value) {
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let newFilter = {
                value: {
                  start: this.$moment.tz(filter.value.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss'),
                  end: this.$moment.tz(filter.value.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
                }
              }
              this.filterForExcel[replaceName] = newFilter.value
            } else {
              delete this.filterForExcel[replaceName]
            }
          } else {
            this.filterForExcel[name] = filter.value
          }

        },
      },
    });
  }
};